<app-service-settings-common
    [settingsKey]="SERVICE_SETTINGS_CONTACTS_TYPE_KEY"
    [title]="'service.settings.contacts.header'"
></app-service-settings-common>
